import styled from 'styled-components';
import { P, fs, radius, eyebrowLabel, onPhone } from '../../theme/tokens';

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

// Responsive KPI row — wraps instead of cramming, unlike the design mock.
export const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
  ${onPhone} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const KpiCard = styled.div`
  padding: 14px 16px;
  background: ${P.white};
  border: 1px solid ${P.line};
  border-radius: ${radius.lg}px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  .eyebrow {
    ${eyebrowLabel}
  }
  .num {
    margin: 6px 0 2px;
    font-size: 26px;
    font-weight: 700;
    line-height: 1.05;
    color: ${P.navyInk};
    font-variant-numeric: tabular-nums;
  }
  .sub {
    font-size: 12px;
    color: ${P.subtle};
  }
  ${onPhone} {
    padding: 12px 14px;
    .eyebrow {
      font-size: 11px;
    }
    .num {
      font-size: 24px;
    }
  }
`;

export const Two = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

export const Four = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  @media (max-width: 920px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  ${onPhone} {
    grid-template-columns: 1fr;
  }
`;

export const BarRows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const BarRow = styled.div`
  .top {
    display: flex;
    justify-content: space-between;
    font-size: ${fs.sm}px;
    margin-bottom: 5px;
  }
  .top b {
    font-variant-numeric: tabular-nums;
  }
  .track {
    height: 8px;
    background: ${P.gray100};
    border-radius: ${radius.pill}px;
    overflow: hidden;
  }
  .fill {
    height: 100%;
    border-radius: ${radius.pill}px;
    background: ${(p) => p.$color || P.navy};
  }
`;

// Leasing funnel — each stage narrower than the last.
export const Funnel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FunnelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  .bar {
    display: flex;
    align-items: center;
    height: 34px;
    min-width: 54px;
    width: ${(p) => p.$pct}%;
    padding: 0 12px;
    border-radius: ${radius.sm}px;
    background: ${P.navy};
    color: ${P.white};
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }
  .label {
    font-size: ${fs.sm}px;
    color: ${P.muted};
  }
  ${onPhone} {
    flex-direction: column-reverse;
    align-items: flex-start;
    gap: 4px;
  }
`;

export const MiniLabel = styled.p`
  margin: 8px 0 0;
  font-size: 12px;
  color: ${P.subtle};
`;

export const Note = styled.p`
  margin: 4px 0 0;
  font-size: 12px;
  color: ${P.subtle};
`;

export const Footer = styled.footer`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 18px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid ${P.line};
`;

export const OutlineButton = styled.button`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 16px;
  border-radius: ${radius.md}px;
  border: 1px solid ${P.border};
  background: ${P.white};
  font-size: ${fs.sm}px;
  font-weight: 600;
  color: ${P.muted};
  cursor: pointer;
  &:hover:not(:disabled) {
    border-color: ${P.navy};
    color: ${P.navy};
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
  &:focus-visible {
    outline: 2px solid ${P.navy};
    outline-offset: 2px;
  }
`;
